import styled, { css } from 'styled-components';

type StyledMedicalFormColumnProps = {
   maxWidth?: number;
};

export const StyledMedicalLeaveFormSectionColumn = styled.div<StyledMedicalFormColumnProps>`
   display: flex;
   flex-direction: column;
   ${(props) =>
      props.maxWidth &&
      css`
         max-width: ${props.maxWidth}px;
      `}
`;
StyledMedicalLeaveFormSectionColumn.displayName = 'StyledMedicalLeaveFormSectionColumn';
